import { Box } from "@mui/material";
import MusicPlayer from "./Player";

const FloatPlayer = () => {
    return (
        <Box
            sx={{
                position: "fixed",
                bottom: "120px",
                right: "0",
                zIndex: "999",
                marginRight: "20px",
                padding: "3px",
            }}
        >
           <MusicPlayer/>
        </Box>
    );
};

export default FloatPlayer;
